module.exports = __webpack_public_path__ + "img/tg_cl03.24a46c75.png";